/**
 * 微信公众号绑定账号页面
 * 2020-10-23 wuw
 */
import React from 'react';

import { Form, Icon, Input, Button } from 'antd';

import "../../../style/common/login.css";

import http from '../../../axios/http';
import messager from '../../ui/messager';
// import server from '../../../axios/server';
import loginbg from '../../../style/img/loginbg.png'
import logo from '../../../style/img/logo-min1.png'
import Loading from '../../ui/Loading';

class BindAccount extends React.Component {

    state = {
        rememberMe: false,
        maskVisible: false,
    }

    componentDidMount() {
        let rememberMe = localStorage.getItem("rememberMe");
        if (rememberMe === "true") {
            let username = localStorage.getItem("username");
            let password = localStorage.getItem("password");
            this.setState({ rememberMe: true, password: password, username: username });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let redirectUri = this.props.redirectUri;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ maskVisible: true });
                http.post({
                    url: '/login',
                    data: values,
                    success: (res) => {
                        this.setState({ maskVisible: false });
                        //登录成功，设置登录状态
                        sessionStorage.setItem("loginStatus", "true");
                        localStorage.setItem("rememberMe", this.state.rememberMe);
                        localStorage.setItem("username", values["username"]);
                        localStorage.setItem("password", values["password"]);
                        http.post({
                            url: "/common/bindOpenid",
                            success: (res) => {
                                //如果有跳转链接，则跳到对应页面
                                if (redirectUri && redirectUri !== "none") {
                                    let uri = unescape(redirectUri);
                                    let redirectUrl = window.location.protocol + "//" + window.location.host + uri;
                                    window.location.replace(redirectUrl);
                                }
                                else {
                                    //否则回到绑定首页
                                    window.location.replace(window.location.href.split("?")[0]);
                                }
                            },
                            error: (e) => {
                                messager.alert(e, "绑定失败，无法获取openid", "error");
                            }
                        });
                    },
                    error: (e) => {
                        this.setState({ maskVisible: false });
                        messager.alert(e, "用户名或密码错误", "error");
                    }
                });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return <div className="wxloginPage">
            <div className="wxloginBanner">
                <div className="wxloginBannerbox">
                    <img src={loginbg} alt="" />
                    <span className="wxloginMask"></span>
                </div>
                <div className="wxlogin-logo">
                    <img src={logo} alt=""></img>
                </div>
            </div>
            <div className="wxlogin">
                <h3>绑定账号</h3>
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item style={{ textAlign: 'right' }}>
                        {getFieldDecorator('username', {
                            rules: [{ required: true, message: '请输入用户名!' }],
                            initialValue: this.state.username
                        })(
                            <Input prefix={<Icon type="user" />} placeholder="用户名" />
                        )}
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'right' }}>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: '请输入密码!' }],
                            initialValue: this.state.password
                        })(
                            <Input prefix={<Icon type="lock" />} type="password" placeholder="密码" />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button bindbtn">
                            绑定
                        </Button>
                    </Form.Item>
                </Form>
            </div>
            <Loading
                visible={this.state.maskVisible}
                message="绑定中"
            />
        </div>
    };
}

export default Form.create()(BindAccount);